import React, { useState, useEffect } from "react";
import styles from "./style.module.css";

const PasswordStrength = props => {
  const { password, ...other } = props;
  const [msg, setMsg] = useState();
  const [strengthLabel, setStrengthLabel] = useState("");

  let strength = 0;
  useEffect(() => {
    if (password.length < 7) {
      setStrengthLabel("none");
      setMsg("Mínino de 7 caracteres na senha.");
    } else {
      password.match(/[a-z]+/) && strength++;
      password.match(/[A-Z]+/) && strength++;
      password.match(/[0-9]+/) && strength++;
      password.match(/[$@#&!]+/) && strength++;

      switch (strength) {
        case 0:
          setStrengthLabel("weak");
          setMsg("Opa! Essa senha ainda está fraca. Adicione números e símbolos para deixá-a mais segura.");
          break;

        case 1:
          setStrengthLabel("weak");
          setMsg("Opa! Essa senha ainda está fraca. Adicione números e símbolos para deixá-a mais segura.");
          break;

        case 2:
          setStrengthLabel("weak");
          setMsg("Opa! Essa senha ainda está fraca. Adicione números e símbolos para deixá-a mais segura.");
          break;

        case 3:
          setStrengthLabel("medium");
          setMsg("Moderada. Ainda dá pra melhorar, tente adicionar novas combinações.");
          break;

        case 4:
          setStrengthLabel("strong");
          setMsg("Super Senha! Agora sim, sua conta está mais segura que uma porta à 7 chaves.");
          break;

        default:
          break;
      }
    }
  }, [password, strength]);

  return (
    <div className={styles.password_strength} {...other}>
      <div className={styles.container} data-strength={strengthLabel}>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <p className={styles.msg}>{msg}</p>
    </div>
  );
};

export default PasswordStrength;
